import React from 'react';

export const ZoomIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 28 28"
      {...props}
    >
      <g data-name="Group 1029">
        <g data-name="Ellipse 66">
          <circle data-name="Ellipse 67" cx={14} cy={14} r={14} fill="#fff" />
        </g>
        <path
          d="M22.55 20.3L19 16.7a.86.86 0 00-.61-.25h-.59a7.43 7.43 0 001.59-4.62 7.51 7.51 0 10-2.89 5.92v.59a.86.86 0 00.25.61l3.6 3.6a.87.87 0 001.23 0l1-1a.89.89 0 00-.03-1.25zM11.83 17A5.17 5.17 0 1117 11.83 5.17 5.17 0 0111.83 17z"
          fill="#26375f"
          data-name="Group 1025"
        />
      </g>
    </svg>
  );
};
